import { useEffect, useState } from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
let cache = null;
let inflight = null;
const listeners = new Set();

const absolutize = (data) => ({
  slots: Object.fromEntries(Object.entries(data.slots || {}).map(([k, v]) => [k, `${BACKEND}${v}`])),
  gallery: (data.gallery || []).map((g) => ({ ...g, url: `${BACKEND}${g.url}` })),
});

export const refreshSiteImages = () => {
  inflight = fetch(`${BACKEND}/api/site-images`)
    .then((r) => (r.ok ? r.json() : { slots: {}, gallery: [] }))
    .catch(() => ({ slots: {}, gallery: [] }))
    .then((data) => {
      cache = absolutize(data);
      listeners.forEach((fn) => fn(cache));
      return cache;
    });
  return inflight;
};

export const useSiteImages = () => {
  const [state, setState] = useState(cache || { slots: {}, gallery: [] });
  useEffect(() => {
    listeners.add(setState);
    if (!cache && !inflight) refreshSiteImages();
    else if (cache) setState(cache);
    return () => listeners.delete(setState);
  }, []);
  return state;
};
